<template>
  <div
    class="cloudprint-listentry"
    >
    <v-btn small v-if="editable" class="mr-2" @click.stop="edit = !edit">
      <TText v-if="edit" value="done" />
      <TText v-else value="rename" />
    </v-btn>
    <slot :edit="edit" />

  </div>
</template>
<script>
  export default {
    props: ['editable'],
    data: () => ({
      edit: false
    }),
  }
</script>
<style>
  .cloudprint-listentry {
    display: flex;
    height: 46px;
    border-bottom: solid 1px white;
    align-items: center;
    padding: 6px;
    cursor: pointer;
    transition: background-color 0.05s ease-in-out;
  }
  .cloudprint-listentry:hover {
    background-color: grey;
  }
</style>
